(function ( $ ) {
    $.fn.inViewport = function() {
        var $window = $(window),
            $elem = $(this),
            docViewTop = $window.scrollTop(),
            docViewBottom = docViewTop + $window.height(),
            elemTop = $elem.offset().top,
            elemBottom = elemTop + $elem.height();
    
        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    };
}( jQuery ));